import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { SizeGuide as SizeGuideCommon, SizeGuideLabel } from '../../../components/SizeGuide';
import './SizeGuideModal.css';

class SizeGuide extends React.Component {
  constructor(props) {
    super(props);

    this.toggleModal = this.toggleModal.bind(this);

    this.state = {
      isOpen: false
    };
  }

  toggleModal() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  render() {
    const { department, s3BasePath, currentCategoryId } = this.props;
    const { isOpen } = this.state;

    return (
      <Fragment>
        <SizeGuideLabel department={department} data-cy="link-size-guide" setSizeGuideVisible={this.toggleModal} />
        <Modal
          className="sizeGuideModal"
          contentLabel="Size Guide Modal"
          isOpen={isOpen}
          onRequestClose={this.toggleModal}
          overlayClassName="sizeGuideModalOverlay"
        >
          <SizeGuideCommon
            department={department}
            isOpen={isOpen}
            closeSizeGuide={this.toggleModal}
            s3BasePath={s3BasePath}
            currentCategoryId={this.props.currentCategoryId}
          />
        </Modal>
      </Fragment>
    );
  }
}

SizeGuide.propTypes = {
  department: PropTypes.string.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  currentCategoryId: PropTypes.string.isRequired
};

export default SizeGuide;
